<template>
  <div>
    <apexchart height="100%" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ["title", "data", "categories", "cores"],

  data() {
    return {
      series: [],
    };
  },

  computed: {

    options: function () {
      return {
        chart: {
          id: "vuechart-example",
          type: "pie",
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.emitirEventoParaAbrirDialog(config);
            },
            dataPointMouseEnter: function(event, chartContext, config) {
              document.body.style.cursor = 'pointer';
            },
            dataPointMouseLeave: function(event, chartContext, config) {
              document.body.style.cursor = '';
            }
          },
        },
        title: {
          text: "",
          align: "center",
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: "Arial",
          },
        },
        dataLabels: {
          enabled: true,
        },
        labels: [],
        colors: [],
        legend: {
          show: false,
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return value + "%";
            },
          },
        },
      };
    },
  },

  created() {
    this.render();
  },

  methods: {
    emitirEventoParaAbrirDialog(config) {
      const chart = {
        categorie: config.dataPointIndex,
        ativar_filtro_comprador: this.title.includes("Comprador"),
      }

      this.$emit('dataPointIndex', chart)
    },

    render() {
      this.series = [];

      this.options.title.text = this.title;
      this.options.labels = this.categories;
      this.options.colors = this.cores;

      this.data.forEach((item) => {
        item = item > 0 ? item : 0;
        this.series.push(parseFloat(item));
      });
    },
  },
};
</script>
